import { DateTime } from 'luxon'

export const checkForDaylightSavingsTime = (
    start: DateTime | string | undefined,
    end: DateTime | string | undefined
): { start: string; end: string } => {
    if (!start || !end) {
        return {
            start: '',
            end: ''
        }
    }
    if (typeof start === 'string') {
        start = DateTime.fromISO(start)
    }

    if (typeof end === 'string') {
        end = DateTime.fromISO(end)
    }

    if (start.offset !== end.offset) {
        if (end.offset > start.offset) {
            // start -> gmt+1; end -> gmt+2 (march)
            const newStart = start.setZone('UTC+2').minus({ hour: 1 })
            return {
                start: newStart.toISO()!,
                end: end.toISO()!
            }
        } else {
            // start -> gmt+2; end -> gmt+1 (october)
            const newStart = start.setZone('UTC+1').plus({ hour: 1 })
            return {
                start: newStart.toISO()!,
                end: end.toISO()!
            }
        }
    }

    return {
        start: start.toISO()!,
        end: end.toISO()!
    }
}
